import { useState, useCallback } from 'react';
import { AppView, ProjectType } from '../types';
import { SidebarMode } from '../components/Sidebar';

/**
 * Custom hook to manage navigation and UI state.
 * Extracted from App.tsx to improve modularity.
 */
export const useNavigation = () => {
    const [currentView, setCurrentView] = useState<AppView>('projects');
    const [sidebarMode, setSidebarMode] = useState<SidebarMode>('translating');
    const [projectDetailTab, setProjectDetailTab] = useState<'translate' | 'train' | 'glossary'>('translate');
    const [returnToFileId, setReturnToFileId] = useState<string | null>(null);
    const [createModalMode, setCreateModalMode] = useState<ProjectType | 'select' | null>(null);
    const isCreateModalOpen = createModalMode !== null;
    const setIsCreateModalOpen = (open: boolean) => !open && setCreateModalMode(null);

    // Prompt Preview State
    const [promptPreview, setPromptPreview] = useState<{ content: string; visible: boolean }>({
        content: '',
        visible: false
    });

    const navigateTo = useCallback((view: AppView) => {
        setCurrentView(view);
    }, []);

    const handleSelectProject = useCallback((projectId: string) => {
        setCurrentView('project-detail');
    }, []);

    const handleSelectFile = useCallback((fileId: string) => {
        setCurrentView('file-detail');
    }, []);

    const handleBackToProjects = useCallback(() => {
        setCurrentView('projects');
    }, []);

    const handleBackToProject = useCallback(() => {
        setCurrentView('project-detail');
    }, []);

    return {
        currentView,
        setCurrentView,
        sidebarMode,
        setSidebarMode,
        projectDetailTab,
        setProjectDetailTab,
        returnToFileId,
        setReturnToFileId,
        isCreateModalOpen,
        setIsCreateModalOpen,
        createModalMode,
        setCreateModalMode,
        promptPreview,
        setPromptPreview,
        navigateTo,
        handleSelectProject,
        handleSelectFile,
        handleBackToProjects,
        handleBackToProject
    };
};
